import { type ItemTypeFilter } from '~/components/Filters/types';
import { type UseClipSearchParamsReturn } from '~/swr-hooks/search/useClipSearchParams';
import { getTypesToFetchFromParams } from '~/swr-hooks/search/utils';

/** Gallery/table pass `hybrid` at runtime even though it is not on `UseClipSearchParamsReturn`. */
type ClipFetchParamsForTotalsKey = UseClipSearchParamsReturn & {
  hybrid?: boolean;
};

/** Matches `usePrivateSearchTotalsQueryKey` / header readers; excludes fetch-only `semantic` / `hybrid`. */
export const buildPrivateSearchTotalsQueryKeyPayload = (
  clipsFetchParams: ClipFetchParamsForTotalsKey,
  typesParam: ItemTypeFilter[],
) => {
  const { semantic: _semantic, hybrid: _hybrid, ...clipParamsForTotalKey } = clipsFetchParams;

  return {
    ...clipParamsForTotalKey,
    types: getTypesToFetchFromParams(typesParam),
  };
};

export type PrivateSearchTotalsQueryKeyPayload = ReturnType<typeof buildPrivateSearchTotalsQueryKeyPayload>;

/** `JSON.parse` is `any`; the signature is produced by `JSON.stringify` of this same payload. */
export const parsePrivateSearchTotalsQueryKeyPayload = (signature: string): PrivateSearchTotalsQueryKeyPayload =>
  JSON.parse(signature);

export type PrivateSearchTotalKey = {
  workspaceId: string | undefined;
  isPrivate: true;
  searchTotalsQueryKey: PrivateSearchTotalsQueryKeyPayload | undefined;
};

export const getPrivateSearchTotalKey = (
  workspaceId: string | undefined,
  searchTotalsQueryKey: PrivateSearchTotalsQueryKeyPayload | undefined,
): PrivateSearchTotalKey => ({
  workspaceId,
  isPrivate: true,
  searchTotalsQueryKey,
});
